export enum Mode {
  Side,
  Center,
}
export enum Size {
  sm = "sm",
  md = "md",
  lg = "lg",
  xl = "xl",
  xxl = "xxl",
}
export enum ActivityType {
  DailyAttendanceToCenters = "dailyattendancetocenters",
  AttendedEvent = "attendedevent",
  Volunteered = "volunteered",
  AttendedProgram = "attendedprogram",
  CompletedSurvey = "completedsurvey",
  ParticipatedInCompetition = "participatedincompetition",
  WonFirstPlace = "wonfirstplace",
  WonSecondPlace = "wonsecondplace",
  WonThirdPlace = "wonthirdplace",
  WelcomePoint = "welcomepoint",
}

export const ActivityTypeList = Object.entries(ActivityType).map(
  ([key, value], index) => ({
    id: index + 1,
    value: value,
    name_en: key.replace(/([A-Z])/g, " $1").trim(), // Convert CamelCase to spaced words
    name_ar: getArabicName(value), // A helper function to return Arabic names
  })
);

function getArabicName(value: string): string {
  const translations: Record<string, string> = {
    dailyattendancetocenters: "الحضور اليومي إلى المراكز",
    attendedevent: "حضر حدثًا",
    volunteered: "تطوع",
    attendedprogram: "حضر برنامجًا",
    completedsurvey: "أكمل استبيانًا",
    participatedincompetition: "شارك في مسابقة",
    wonfirstplace: "فاز بالمركز الأول",
    wonsecondplace: "فاز بالمركز الثاني",
    wonthirdplace: "فاز بالمركز الثالث",
    welcomepoint: "نقطة ترحيب",
  };

  return translations[value] || value;
}
